import {route as ziggyRoute, ZiggyVue, useRoute} from 'ziggy-js-original';

/**
 * Ziggy wrapper to add trailing slash to URLs
 */
export function route(name, params = {}, absolute = true, config = Ziggy) {
  const url = ziggyRoute(name, params, absolute, config);
  const [path, extra = ''] = url.split(/([?#].*)/);

  // Already has trailing slash
  if (path.endsWith("/")) return url;

  // Anchor link doesn't have the slash removed
  if (extra.startsWith('#')) return url;

  // If it's a file, don't add slash
  if (/\.(csv|html?|json|pdf|txt)$/.test(path)) return url;

  return path + "/" + extra;
}

// Re-export original Ziggy functions
export {ZiggyVue};
export {useRoute};